import { Divider } from '@pepper/ui'

import DocumentTitle from '../Navigation/DocumentTitle/DocumentTitle'
import CollaborationAvatars from '../CollaborationAvatars/CollaborationAvatars'
import DocUpdateStatus from './components/DocUpdateStatus/DocUpdateStatus'
import AssignmentMetadata from './components/AssignmentMetadata/AssignmentMetadata'

import styles from './_.module.css'

interface Props {
  docType: PepperDocTypes
  docId: string
  initialTitle?: string
  platform: Platforms
  rightSlot: React.ReactNode
  // v2 yjs: render CollaborationAvatars (uses usePresence). requires the
  // topbar to be mounted inside <DocV2Provider>. v1/non-yjs docs render
  // nothing in this slot — awareness is no longer wired for those.
  useYjsV2?: boolean
}

function Topbar({
  docId,
  docType,
  initialTitle,
  platform,
  rightSlot,
  useYjsV2,
}: Props) {
  return (
    <section className={styles.container}>
      <div className={styles.leftContainer}>
        <DocumentTitle
          docType={docType}
          initialTitle={initialTitle}
          platform={platform}
          docId={docId}
        />
        <DocUpdateStatus />
      </div>

      <div className={styles.rightContainer}>
        <AssignmentMetadata platform={platform} />
        <Divider type="vertical" className={styles.divider} />
        {useYjsV2 && <CollaborationAvatars />}
        <Divider type="vertical" className={styles.divider} />
        {rightSlot}
      </div>
    </section>
  )
}

export default Topbar
